import {Component, Input} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {appConfig} from '../../shared/app.config';
import {AssetAuditComponent} from '../asset-audit/asset-audit.component';

@Component({
  selector: 'lib-item-summary-asset-action-popup',
  templateUrl: './asset-action-popup.component.html',
  styleUrls: ['./asset-action-popup.component.scss']
})
export class AssetActionPopupComponent {

  @Input() popupTitle: string;
  @Input() equipId: number;
  @Input() assetId: number;

  displayAssetInformation: boolean;

  constructor(private dialog: MatDialog) {
  }

  public openAssetAuditDialog() {
    this.displayAssetInformation = !this.equipId;
    if (this.displayAssetInformation) {
      this.dialog.open(AssetAuditComponent, {
        panelClass: 'mat-panel--full-height',
        data: {
          modalTitle: this.popupTitle,
          assetId: this.assetId
        }
      });
    } else {
      window.open(appConfig.getItemHistoryPageUrl(this.equipId), appConfig.newWindowOptions);
    }
  }
}
